import { useAppSelector } from '../../../../redux/store';
import { CollectionTriggersAndSequencesPage } from './CollectionTriggersAndSequencesPage';

// Thin page wrapper for the standalone `/collectionSequencesAndTriggers` route - supplies the
// current supplier so CollectionTriggersAndSequencesPage doesn't need to know about redux itself.
function SupplierCollectionTriggersAndSequences() {
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  return (
    <div className="w-full h-full px-4 pb-4">
      <CollectionTriggersAndSequencesPage supplierId={currentSupplier?.id ?? ''} />
    </div>
  );
}

export default SupplierCollectionTriggersAndSequences;
